export enum MessageCategoryType {
    IN = 'IN',
    OUT = 'OUT',
    /** TODO: ARCHIVE is only available locally it does not exist in the API, but we keep it around in order not to break too much for now could be done with archived property */
    ARCHIVE = 'ARCHIVE',
    ROOT = 'ROOT',
}
